import { render, staticRenderFns } from "./LmAutomation.vue?vue&type=template&id=887ca634&scoped=true&"
import script from "./LmAutomation.vue?vue&type=script&lang=js&"
export * from "./LmAutomation.vue?vue&type=script&lang=js&"
import style0 from "./LmAutomation.vue?vue&type=style&index=0&id=887ca634&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887ca634",
  null
  
)

export default component.exports